import styled from 'styled-components/macro'

export const CloseButton = styled.button`
  position: absolute;
  top: 2rem;
  right: 2rem;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  color: ${(props) => props.theme.color.elementBgSecond};
  background-color: ${(props) => props.theme.color.transparent};
  border: none;
  outline: none;
  cursor: pointer;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    top: 2rem;
  `};
`
